module.exports = __webpack_public_path__ + "static/media/building_unselected.4bc577a1.svg";